$(document).ready(function() {

  // Date pickers initialisation
  $('.date-of-birth').datepicker({
    orientation: "bottom",
    format: "dd/mm/yyyy",
    autoclose: true,
    container: '.date'
  });

  $('.expiry-date').datepicker({
    orientation: "bottom",
    format: "dd/mm/yyyy",
    autoclose: true,
    container: '.expiry-date'
  });

  $('.issue-date').datepicker({
    orientation: "bottom",
    format: "dd/mm/yyyy",
    autoclose: true,
    container: '.issue-date'
  });

  $('.bttn-calendar.js-dob-date').on('click', function() {
    $('.date.date-of-birth input.form-control').focus();
  });

  $('.bttn-calendar.js-issue-date').on('click', function() {
    $('.date.issue-date input.form-control').focus();
  });

  $('.bttn-calendar.js-expiry-date').on('click', function() {
    $('.date.expiry-date input.form-control').focus();
  });



});
